import routes from 'sitewide-js/core_pre_webpack/routes';
import { fetchWithCsrf } from 'js/utils';

export const ignoreSuggestion = async (userId: number, source: string) => {
  const response = await fetchWithCsrf(
    routes.api_v0_suggestions_following_path({
      subdomain_param: 'api',
      id: userId,
      s: source,
    }),
    { method: 'DELETE' },
  );
  if (response.status !== 200) {
    throw new Error('Failed to ignore user suggestion');
  }
};
